import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import jesperPhoto from "@/assets/jesper-west.jpg";
import { useTranslation } from "@/i18n/useTranslation";

const ease = [0.16, 1, 0.3, 1] as const;

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="section-padding" style={{ background: "var(--gradient-subtle)" }}>
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, ease }}
          >
            <p className="label-text mb-3">{t.about.label}</p>
            <div className="flex flex-col md:flex-row gap-10 md:gap-14 items-start">
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.15, ease }}
                className="shrink-0 mx-auto md:mx-0"
              >
                <div className="w-56 h-56 md:w-64 md:h-64 rounded-2xl overflow-hidden border-2 border-border glow-border">
                  <img
                    src={jesperPhoto}
                    alt="Jesper West — EastWest IT Consultant"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </motion.div>

              <div className="flex-1">
                <h2 className="font-display font-bold text-foreground mb-6">
                  {t.about.heading}
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-8 text-lg font-body">
                  {t.about.body}
                </p>
                <div className="grid sm:grid-cols-2 gap-4">
                  {t.about.highlights.map((h, i) => (
                    <motion.div
                      key={i}
                      initial={{ opacity: 0, x: -20 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.4, delay: i * 0.1, ease }}
                      className="flex items-center gap-3 bg-card/50 border border-border rounded-lg px-4 py-3 glow-border"
                    >
                      <CheckCircle2 size={18} className="shrink-0" style={{ color: "hsl(var(--success))" }} />
                      <span className="text-foreground text-sm font-medium font-body">{h}</span>
                    </motion.div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
